export const SURVEY_LAUNCH_CONSTANTS = Object.freeze({
  FEOT: {
    CUSTOM_PACING: {
      DEFAULT_PACING_INTERVAL: 1,
      DEFAULT_PACING: 'days',
    },
  },
});
